<template>
  <nav class="discover__nav" :class="{'header--white': $route.name === 'Discovery'}">

    <div class="discover__nav__back">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="29" viewBox="0 0 16 29" v-if="$route.name === 'Benefits' || $route.name === 'Discovery'">
          <g fill="#C24E5C" fill-rule="evenodd">
              <path d="M0 14.837c4.05 0 7.333 3.17 7.333 7.081C7.333 25.83 4.05 29 0 29M0 0c4.05 0 7.333 3.17 7.333 7.081 0 3.91-3.283 7.082-7.333 7.082M16 29c-4.051 0-7.333-3.17-7.333-7.08 0-3.912 3.282-7.083 7.333-7.083"/>
          </g>
      </svg>
      <svg width="16px" height="29px" viewBox="0 0 16 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-else-if="$route.name === 'Thankyou' || $route.name === 'Registration'">
          <!-- Generator: Sketch 60 (88103) - https://sketch.com -->
          <title>logo</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="logo" fill="#000000">
                  <path d="M0,14.837 C4.05,14.837 7.333,18.007 7.333,21.918 C7.333,25.83 4.05,29 0,29 M0,0 C4.05,0 7.333,3.17 7.333,7.081 C7.333,10.991 4.05,14.163 0,14.163 M16,29 C11.949,29 8.667,25.83 8.667,21.92 C8.667,18.008 11.949,14.837 16,14.837" id="Shape"></path>
              </g>
          </g>
      </svg>
    </div>

    <span
      class="discover__nav__back ml-auto"
      :class="{'more__visible': $route.name === 'Thankyou'}"
      v-if="$route.name !== 'Index' && $route.name !== 'IntroDiscover'"
      @click="$router.push('intro-discover')"
      @mouseover="MX_isZoom(true)"
      @mouseleave="MX_isZoom(false)"
    >
      Back
    </span>

    <button
      v-if="$route.name !== 'Index'"
      @click="playPauseAudio"
      id="mute_btn"
      class="equalizer__box"
      :class="{
        'ml-auto': $route.name === 'IntroDiscover',
        'header--white': $route.name === 'Discovery',
        'equalizer__box--off': !isMusicOn,
        'index--page': $route.name == 'Index'
      }"
      @mouseover="MX_isZoom(true)"
      @mouseleave="MX_isZoom(false)"
    >
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>

      <!-- Main song -->
      <audio ref="audioFile" loop muted autoplay preload="auto"></audio>
      <!-- Cross-fade song -->
      <audio ref="openAudioFile" muted autoplay preload="auto"></audio>
      <!-- Cross-fade song -->
      <audio ref="crossAudioFile" loop muted autoplay preload="auto"></audio>

    </button>

    <!-- <router-link
      v-if="startPauseJourney && $route.name !== 'Index'"
      :to="introDiscoveryLinkProp"
      class="ml-auto discover__nav__next"
      @mouseover.native="MX_isZoom(true)"
      @mouseleave.native="MX_isZoom(false)"
    >
      {{introDiscoveryTextProp}}
    </router-link>

    <span
      v-else-if="!isCycleOnProp && $route.name !== 'Index'"
      @click="handleClickStartStopJourney"
      class="ml-auto discover__nav__next"
    >
      <router-link
        v-if="introDiscoveryLinkProp"
        :to="introDiscoveryLinkProp"
        @mouseover.native="MX_isZoom(true)"
        @mouseleave.native="MX_isZoom(false)"
      >
        {{introDiscoveryTextProp}}
      </router-link>
      <span v-else :class="{'forward__link--disabled': $route.name === 'Registration'}">
        {{startPauseText}} Journey
      </span>
    </span> -->

  </nav>
</template>

<script>
import { isZooming } from '../mixins/isZooming'
import { mapGetters } from 'vuex'

export default {
  name: 'TheHeader',
  props: {
    introDiscoveryTextProp: {
      type: String,
      required: false
    },
    introDiscoveryLinkProp: {
      type: String,
      required: false
    },
    isCycleOnProp: {
      type: Boolean,
      required: false
    },
    musicFromHomeProp: {
      type: Boolean,
      required: false
    }
  },
  mixins: [
    isZooming
  ],
  data () {
    return {
      startPauseJourney: false,
      startPauseText: 'Pause',
      showHidePlayer: false,
      currentVolume: 1,
      intervalPlayer: 200,
      currentPlayerTime: 0,
      interval: null
    }
  },
  computed: {
    isMusicOn: {
      get () {
        return this.$store.state.audio.isMusicOn
      },
      set (payload) {
        this.$store.commit('updateAudioStatus', payload)
      }
    },
    ...mapGetters([
      'generateAudioPath',
      // 'generateHoverAudioPath',
      'generateOpenAudioPath',
      'generateCrossAudioPath'
    ])
  },
  mounted () {
    this.initStartPauseJourney()
    if (this.$route.name === 'IntroDiscover') {
      // this.isMusicOn = true
      // if (!this.isMusicOn) {
      //   this.playPauseAudio()
      // }
    } else if (this.$route.name === 'Index') {
      if (this.isMusicOn) {
        this.playPauseAudio()
      }
    }
    setInterval(() => {
      // if (this.generateOpenAudioPath.currentTime > 0) console.log(this.generateOpenAudioPath.currentTime)
      if (this.isMusicOn && this.generateAudioPath.currentTime > 437) {
        this.generateAudioPath.pause()
        this.generateAudioPath.currentTime = 0
        setTimeout(() => {
          if (this.isMusicOn) {
            this.generateAudioPath.volume = 0
            this.generateAudioPath.play()
            let currentVolume = 0
            let volumeUp = setInterval(() => {
              currentVolume += 0.05
              this.generateAudioPath.volume = currentVolume < 1 ? currentVolume : 1
              if (this.generateAudioPath.volume === 1) {
                clearInterval(volumeUp)
              }
            }, 200)
          }
        }, 8000)
      }
    }, 3000)
  },
  updated () {
    this.$root.$on('playMusic', isPlayerOn => {
      console.log('emit')
      if (isPlayerOn && this.isMusicOn) {
        this.fadeDown()
        this.generateCrossAudioPath.volume = 0
        this.generateCrossAudioPath.pause()
        setTimeout(() => {
          this.isMusicOn = true
          this.generateAudioPath.volume = 0
          this.generateAudioPath.play()
          let currentVolume = 0
          let volumeUp = setInterval(() => {
            currentVolume += 0.05
            this.generateAudioPath.volume = currentVolume < 1 ? currentVolume : 1
            if (this.generateAudioPath.volume === 1) {
              clearInterval(volumeUp)
            }
          }, 200)
        }, 4000)
      }
    })
    // TODO:
    // DISABLED FOR NOW
    // this.isMusicOn = this.musicFromHomeProp
  },
  methods: {
    initStartPauseJourney () {
      if (!this.introDiscoveryLinkProp) {
        this.startPauseJourney = false
      } else {
        this.startPauseJourney = true
      }
    },
    handleClickStartStopJourney () {
      this.startPauseText === 'Pause' ? this.startPauseText = 'Start' : this.startPauseText = 'Pause'
      if (this.startPauseText === 'Start') {
        this.$emit('handlePlayPause', true)
      } else {
        this.$emit('handlePlayPause', false)
      }
    },
    playPauseAudio () {
      this.isMusicOn = !this.isMusicOn
      // this.$root.$on('isFadeDownMusic', isMusicOnHover => {
      //   if (isMusicOnHover && this.isMusicOn) {
      //     let volumeDown = setInterval(() => {
      //       // When player is on, volume is at max peak
      //       if (this.currentVolume > 0) {
      //         this.currentVolume -= 0.15
      //         // Handle if volume goes below 0
      //         if (this.currentVolume < 0) {
      //           this.currentVolume = 0
      //         }
      //         // Decrease the volume every 200ms
      //         this.generateAudioPath.volume = this.currentVolume.toFixed(2)
      //       } else {
      //         // Reset to defaults
      //         this.isMusicOn = false
      //         this.currentVolume = 0
      //         clearInterval(volumeDown)
      //         // After volume is at 0, play the cross fade sound
      //         this.generateCrossAudioPath.play()
      //       }
      //     }, this.intervalPlayer)
      //   }
      // })

      // // After user removes the focus from "Discover" on homepage
      // this.$root.$on('isFadeInMusic', isMusicOffHover => {
      //   if (isMusicOffHover && !this.isMusicOn) {
      //     this.currentVolume = 1
      //     this.generateAudioPath.volume = 1
      //     this.isMusicOn = true
      //     this.generateCrossAudioPath.pause()
      //     this.currentPlayerTime = this.generateAudioPath.currentTime
      //     this.generateAudioPath.play()
      //   }
      // })
      if (this.isMusicOn) {
        this.generateAudioPath.volume = 0
        this.generateAudioPath.play()
        let currentVolume = 0
        let volumeUp = setInterval(() => {
          if (this.generateAudioPath.volume === 1) {
            clearInterval(volumeUp)
          }
          currentVolume += 0.025
          this.generateAudioPath.volume = currentVolume < 1 ? currentVolume : 1
        }, 100)
      } else {
        this.generateAudioPath.pause()
        this.generateAudioPath.volume = 1
      }
      // this.isMusicOn ? this.generateOpenAudioPath.play() : this.generateOpenAudioPath.pause()
    },
    fadeDown () {
      let currentVolume1 = this.generateOpenAudioPath.volume
      this.volumeDown = setInterval(() => {
        if (this.generateOpenAudioPath.volume === 0) {
          this.generateOpenAudioPath.currentTime = 0
          this.generateOpenAudioPath.pause()
          // this.isMusicOn = !this.isMusicOn
          clearInterval(this.volumeDown)
        }
        currentVolume1 -= 0.025
        this.generateOpenAudioPath.volume = currentVolume1 > 0 ? currentVolume1 : 0
      }, 100)
    }
  }
}
</script>
